import { render, staticRenderFns } from "./FormularioBroker.vue?vue&type=template&id=a2231484&scoped=true"
import script from "./FormularioBroker.vue?vue&type=script&lang=js"
export * from "./FormularioBroker.vue?vue&type=script&lang=js"
import style0 from "./FormularioBroker.vue?vue&type=style&index=0&id=a2231484&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2231484",
  null
  
)

export default component.exports